import FreyaStorage from "../../../../common/freyaStorage/FreyaStorage";
import { FREYA_SCANNED_BADGES_CHECK_TIMEOUT } from "../../../../common/constants";
import { useRef } from "react";

export const useClearScannedBadges = () => {
  const interval = useRef<NodeJS.Timeout>();

  const clearFreyaScannedBadgesPeriodically = () => {
      interval.current = setInterval(() => {
        FreyaStorage.clearScannedBadgesOlderThanXMinutes();
      }, FREYA_SCANNED_BADGES_CHECK_TIMEOUT);
  };

  const stopClearingScannedBadges = () => {
    clearInterval(interval.current!);
  };

  return { clearFreyaScannedBadgesPeriodically, stopClearingScannedBadges };
};
